import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react-atlantic/react-atlantic/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import { Message, MessageLight } from './Message';
import { WrapperVertical, WrapperHorizontal } from '../../gatsby-theme-docz/components/Wrapper';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "message"
    }}>{`Message`}</h1>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic usage`}</h2>
    <Playground __position={0} __code={'<Message>Message</Message>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Message,
      MessageLight,
      WrapperVertical,
      WrapperHorizontal,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <Message mdxType="Message">Message</Message>
    </Playground>
    <h2 {...{
      "id": "types"
    }}>{`Types`}</h2>
    <Playground __position={1} __code={'<WrapperHorizontal>\n  <Message type=\"default\">Default</Message>\n  <Message type=\"primary\">Primary</Message>\n  <Message type=\"success\">Success</Message>\n  <Message type=\"warning\">Warning</Message>\n  <Message type=\"error\">Error</Message>\n  <Message type=\"info\">Info</Message>\n</WrapperHorizontal>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Message,
      MessageLight,
      WrapperVertical,
      WrapperHorizontal,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <WrapperHorizontal mdxType="WrapperHorizontal">
        <Message type="default" mdxType="Message">Default</Message>
        <Message type="primary" mdxType="Message">Primary</Message>
        <Message type="success" mdxType="Message">Success</Message>
        <Message type="warning" mdxType="Message">Warning</Message>
        <Message type="error" mdxType="Message">Error</Message>
        <Message type="info" mdxType="Message">Info</Message>
    </WrapperHorizontal>
    </Playground>
    <h2 {...{
      "id": "other-props"
    }}>{`Other props`}</h2>
    <h3 {...{
      "id": "isreversedcolor"
    }}>{`isReversedColor`}</h3>
    <Playground __position={2} __code={'<WrapperVertical>\n  <Message type=\"primary\" isReversedColor>\n    Message with reversed color\n  </Message>\n  <Message type=\"success\" isReversedColor>\n    Message with reversed color\n  </Message>\n  <Message type=\"warning\" isReversedColor>\n    Message with reversed color\n  </Message>\n  <Message type=\"error\" isReversedColor>\n    Message with reversed color\n  </Message>\n  <Message type=\"info\" isReversedColor>\n    Message with reversed color\n  </Message>\n</WrapperVertical>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Message,
      MessageLight,
      WrapperVertical,
      WrapperHorizontal,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <WrapperVertical mdxType="WrapperVertical">
        <Message type="primary" isReversedColor mdxType="Message">
            Message with reversed color
        </Message>
        <Message type="success" isReversedColor mdxType="Message">
            Message with reversed color
        </Message>
        <Message type="warning" isReversedColor mdxType="Message">
            Message with reversed color
        </Message>
        <Message type="error" isReversedColor mdxType="Message">
            Message with reversed color
        </Message>
        <Message type="info" isReversedColor mdxType="Message">
            Message with reversed color
        </Message>
    </WrapperVertical>
    </Playground>
    <h2 {...{
      "id": "other-views"
    }}>{`Other views`}</h2>
    <h3 {...{
      "id": "messagelight"
    }}>{`MessageLight`}</h3>
    <Playground __position={3} __code={'<WrapperHorizontal>\n  <MessageLight type=\"default\">MessageLight</MessageLight>\n  <MessageLight type=\"primary\">MessageLight</MessageLight>\n  <MessageLight type=\"success\">MessageLight</MessageLight>\n  <MessageLight type=\"warning\">MessageLight</MessageLight>\n  <MessageLight type=\"error\">MessageLight</MessageLight>\n  <MessageLight type=\"info\">MessageLight</MessageLight>\n</WrapperHorizontal>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Message,
      MessageLight,
      WrapperVertical,
      WrapperHorizontal,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <WrapperHorizontal mdxType="WrapperHorizontal">
        <MessageLight type="default" mdxType="MessageLight">MessageLight</MessageLight>
        <MessageLight type="primary" mdxType="MessageLight">MessageLight</MessageLight>
        <MessageLight type="success" mdxType="MessageLight">MessageLight</MessageLight>
        <MessageLight type="warning" mdxType="MessageLight">MessageLight</MessageLight>
        <MessageLight type="error" mdxType="MessageLight">MessageLight</MessageLight>
        <MessageLight type="info" mdxType="MessageLight">MessageLight</MessageLight>
    </WrapperHorizontal>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      